'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSeatedProductOwned = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _getHasHigherTieredProduct = require('self-service-api/api/getHasHigherTieredProduct');

var _getIsProductOwned = require('self-service-api/api/getIsProductOwned');

var _getMerchandiseIdOwned = require('self-service-api/api/getMerchandiseIdOwned');

var _MerchandiseIdLists = require('self-service-api/constants/MerchandiseIdLists');

var _productProperties = require('ui-addon-upgrades/_core/common/constants/productProperties');

var _productProperties2 = _interopRequireDefault(_productProperties);

var _products = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/products');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSeatedProductOwned = exports.getSeatedProductOwned = function getSeatedProductOwned() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      upgradeProduct = _ref.upgradeProduct,
      product = _ref.product;

  if (product !== _products.productTypes.SALES && product !== _products.productTypes.SERVICE) {
    return _q2.default.Promise.resolve(null);
  }

  var productProperty = _productProperties2.default[upgradeProduct];

  if (!productProperty || !productProperty.merchandiseId || !_MerchandiseIdLists.SEATED_MERCHANDISE_ID_TIERS[productProperty.merchandiseId]) {
    return _q2.default.Promise.resolve(null);
  }
  var merchandiseId = productProperty.merchandiseId;

  var seatedMerchandiseIdTier = _MerchandiseIdLists.SEATED_MERCHANDISE_ID_TIERS[merchandiseId];
  return (0, _getIsProductOwned.getIsProductOwned)(merchandiseId).then(function (isProductOwned) {
    return isProductOwned ? merchandiseId : _q2.default.Promise.all([(0, _getHasHigherTieredProduct.getHasHigherTieredProduct)(merchandiseId), (0, _getMerchandiseIdOwned.getMerchandiseIdOwned)(seatedMerchandiseIdTier)]).then(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          hasHigherTieredProduct = _ref3[0],
          merchIdOwned = _ref3[1];

      if (hasHigherTieredProduct && merchIdOwned) return merchIdOwned;
      return null;
    });
  }).catch(function () {
    return null;
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/eligibility/getSeatedProductOwned.js
// module id = 477
// module chunks = 3 4 5